var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardTemplate',[(_vm.getRule ==='board' )?_c('div',[_c('Maintenance')],1):_c('DepartmentList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }